var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[(_vm.agreement.required)?_c('span',{staticClass:"required"},[_vm._v("Pole wymagane. ")]):_vm._e(),_vm._v(" Wyrażam zgodę na otrzymywanie drogą elektroniczną informacji handlowych dotyczących Brutto sp. z o.o. z siedzibą w Warszawie, na mój adres e-mail udostępniony przez Autopay S.A. z siedzibą w Sopocie. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }